// src/components/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const getDefaultLanguage = () => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) return savedLanguage;

    const userLang = navigator.language || navigator.languages[0] || 'en'; // Fallback to 'en' if undefined
    return userLang.startsWith('ar') ? 'ar' : 'en'; // Check if Arabic is the preferred language
  };

  const [language, setLanguage] = useState(getDefaultLanguage);

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'ar' : 'en';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const toggleLanguageMen = (lang) => {
    const newLanguage = lang ;
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage , toggleLanguageMen}}>
      {children}
    </LanguageContext.Provider>
  );
};
